import { Brand } from './brand.enum';
import { UserStatus } from './user-status.enum';

/**
 * Contract data properties
 */
export class ContractData {
    public linkedAccounts: string;
    public portfolioLength: number;
    public userStatus: UserStatus;
    public mixedContracts: string;
    public contractType: string;
    public appTitle: string;
    public loggedContractBrand: Brand;
    public displayedBrand: Brand;
    public offer: string;
    public departmentCode?: string;
    public departmentLabel?: string;
    public geographicalArea?: string;
}
